<template>
  <div>
    <stepPan :currStep="1"></stepPan>
    <div id="totalMonetPan">总金额: {{ sumMoney / 100 }} 元</div>
    <div id="choseTypePan">
      <span class="choseType">
        <img
          @click="chooseWeiXinPayTypeFun"
          style="height: 60px;"
          src="static/images/fg/pay/wechat.png"
        />
      </span>
      <span class="choseType">
        <img
          @click="chooseZhiFuBaoPayTypeFun"
          style="height: 60px;"
          src="static/images/fg/pay/alipay.png"
        />
      </span>
      <span class="choseType" v-if="false">
        <img
          @click="chooseYinLianPayTypeFun"
          style="height: 60px;"
          src="static/images/fg/pay/union.png"
        />
      </span>
    </div>
    <div id="bnPan">
      <span
        style="cursor: pointer;"
        type="primary"
        @click="goBackFun"
        >返回上一步</span
      >
    </div>
  </div>
</template>

<script>
import stepPan from '../tools/setps'
export default {
  emits: ['gotoRealPayPageEvent', 'goBackEvent'],
  props: {
    scId: Number
  },
  components: {
    stepPan
  },
  data () {
    return {
      sumMoney: null, // 需要支付的总金额
      addDateTime: null, // 购物车创建的时间 (暂时不展示)
      withFP: false, // 是否开发票 (暂时不展示)
      recordInformationDetails: null // 购物车里面的详细勾选信息 (暂时不展示)
    }
  },
  mounted () {
    const api = '/md/front/shopping/cart/getOneShoppingCartById'
    const params = {
      scId: this.scId
    }
    this.axios.post(api, this.$stringify(params)).then(res => {
      if (res.status === 200) {
        // 获取某一购物车的详细信息
        const d = res.data
        // console.log(d)
        this.sumMoney = parseInt(d.scTotalPaid) // scMoney
        this.addDateTime = d.scAddDate
        this.withFP = d.scFaPiaoTag
        this.recordInformationDetails = d.logs
      }
    })
  },
  methods: {
    goBackFun () {
      this.$emit('goBackEvent')
    },
    chooseWeiXinPayTypeFun () {
      this.updatePayTypeOperationFun('weixin')
    },
    chooseZhiFuBaoPayTypeFun () {
      this.updatePayTypeOperationFun('zhifubao')
    },
    chooseYinLianPayTypeFun () {
      this.updatePayTypeOperationFun('yinlian')
    },
    updatePayTypeOperationFun (payType) {
      const api = '/md/front/shopping/cart/payTypeChoose'
      const params = {
        scId: this.scId,
        payType: payType
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          this.$emit('gotoRealPayPageEvent', payType, this.sumMoney)
        }
      })
    }
  }
}
</script>

<style scoped>
#totalMonetPan {
  width: 100%;
  height: 180px;
  color: #fff;
  font-size: 30px;
  padding-top: 70px;
  box-sizing: border-box;
  text-align: center;
}

#choseTypePan {
  text-align: left;
  padding: 40px 0 0 50px;
}

.choseType {
  display: inline-block;
  margin-left: 200px;
}

#bnPan {
  height: 200px;
  box-sizing: border-box;
  -moz-box-sizing: border-box; /* Firefox */
  -webkit-box-sizing: border-box; /* Safari */
  padding-top: 160px;
}

#bnPan .el-link.el-link--primary {
  color: #fff;
  font-size: 20px;
}

.choseType img {
  cursor: pointer;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
}
.choseType img :hover {
  border: 2px;
  border-color: crimson;
}
</style>
